var VideoBg = (function() {
	'use strict';

	var $_els = $('.bg-container');

	function init() {
		if ($_els.length === 0) return;

		console.warn('Video backgrounds module loaded');

		init_events();
	}

	function init_events() {

		// TODO -- Stop html5 video on vimeo play.

		// $_els.each(function(index, el) {
		// 	var vid = el.querySelector('iframe');
		// 	var player = new Vimeo.Player(vid, {loop:true});
		//
		// 	player.play();
		// });

	}

	return {
		init:init
	};
}());
